module.exports = __webpack_public_path__ + "img/logo_nf.89998177.webp";